module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/swear-words/swear-words.component.scss
// module id = ./src/app/swear-words/swear-words.component.scss
// module chunks = main